import React, { useState } from 'react';
import SearchCakeOrders from '../cakes/SearchCakeOrders';
import SearchBreadOrders from '../bread/SearchBreadOrders';
import RoscaOrders from '../roscas/RoscaOrders';
import './Common.css';

export default function Search() {
	const [searchType, setSearchType] = useState('cake');

	const renderSearch = () => {
		switch (searchType) {
			case 'cake':
				return <SearchCakeOrders />;
			case 'bread':
				return <SearchBreadOrders />;
			case 'rosca':
				return <RoscaOrders />;
			default:
				return <SearchCakeOrders />;
		}
	};

	return (
		<div>
			<div className='buttonContainer'>
				<button className={`switchButton ${searchType === 'cake' ? 'active' : ''}`} onClick={() => setSearchType('cake')}>🎂 Pasteles</button>
				<button className={`switchButton ${searchType === 'bread' ? 'active' : ''}`} onClick={() => setSearchType('bread')}>🥖 Panes</button>
				<button className={`switchButton ${searchType === 'rosca' ? 'active' : ''}`} onClick={() => setSearchType('rosca')}>👑 Roscas</button>
			</div>
			{renderSearch()}
		</div>
	);
}
